module.exports = __webpack_public_path__ + "img/education-partner.f86466b0.svg";